// extracted by css-extract-rspack-plugin
export default {"setting":"EmployeeFieldGroupPermission__setting--NfOQ0"};